<template>
  <div>
    <v-sheet style="background-color:var(--v-brandLight-base);border-radius: 10px;" class="pa-2 mr-1 mt-12 mb-2">
      <v-card flat shaped class="pa-4 mt-1" color="white">
        <QuickLinkComponents />
      </v-card>
    </v-sheet>

    <v-card flat class="mb-2" color="brandLight" ripple hover>
      <v-col cols="12">
        <v-expansion-panels focusable flat tile>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <b>
                <span style="font-size: 20px; margin-right: 12px;">🎂</span>
                <span class="text-lg font-semibold text-gray-800" style="font-family: Georgia, 'Times New Roman', Times, serif;">Birthdays 🎉</span>
              </b>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <!-- Instructor Birthdays -->
              <div v-if="bday_list.length">
                <v-subheader class="font-weight-bold text--primary">🧑‍🏫 Instructors</v-subheader>
                <v-row dense>
                  <v-col v-for="(i, index) in bday_list" :key="'inst-' + index" cols="12"
                    class="d-flex align-center mb-3">
                    <v-avatar size="45" class="mr-3 elevation-2">
                      <v-img v-if="i.photo_path" :src="awspath + i.photo_path" />
                      <v-icon v-else x-large color="primary">mdi-account-circle</v-icon>
                    </v-avatar>
                    <span style="font-size: 15px; font-weight: 500;">🎈 {{ i.inst }}</span>
                  </v-col>
                </v-row>
              </div>

              <!-- Student Birthdays -->
              <div v-if="isBirthdayLoaded && bday_list_student.length" class="mt-4">
                <v-subheader class="font-weight-bold text--primary">🎓 Students</v-subheader>
                <v-row dense>
                  <v-col v-for="(s, sIndex) in bday_list_student" :key="'stud-' + sIndex" cols="12"
                    class="d-flex align-center mb-3">
                    <v-avatar size="45" class="mr-3 elevation-2">
                      <v-img v-if="s.photo_path" :src="awspath + s.photo_path" />
                      <v-icon v-else x-large color="primary">mdi-account-circle</v-icon>
                    </v-avatar>
                    <div>
                      <div style="display: flex; align-items: flex-start;font-size: 15px; font-weight: 500;"><span style="width: 22px;">🎂</span><span>{{ s.student }}</span></div>
                      <div style="font-size: 13px; color: #666;">
                        🏫  <span class="ml-1">{{ s.standard }} - {{ s.division }}</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else-if="!isBirthdayLoaded">
                <v-skeleton-loader type="list-item-three-line" class="mx-2"
                        style="height:80px; width:150px; border-radius:12px;" />
              </div>
              <div v-else class="text-center mt-4 grey--text text--darken-1">
                🎂 No student birthdays today
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-card>

    <div>
      <!-- 🎂 Animated Birthday Dialog -->
      <v-dialog v-model="showBirthdayDialog" max-width="500" transition="scale-transition" persistent>
        <v-card class="animated-dialog pa-4">
          <!-- 🎉 Title -->
          <v-card-title class="headline font-weight-bold dialog-text-animate justify-center text-h5 text-center">
            🎉 Happy Birthday, {{ user.name }}! 🎂
          </v-card-title>
          <!-- ✨ Optional birthday image -->
          <v-img :src="require('@/assets/gift.gif')" contain max-height="120" class="my-2 mx-auto"></v-img>

          <!-- 💬 Message -->
          <v-card-text class="dialog-text-animate text-center text-subtitle-1">
            <p>Wishing you a fantastic day filled with joy, success, and smiles! ✨</p>
            <p class="font-italic">Enjoy every moment — it’s your day! 🎊</p>
          </v-card-text>

          <!-- ✅ Button -->
          <v-card-actions class="justify-center">
            <v-btn color="deep-purple accent-4" dark @click="closeDialog">
              🎁 Thanks!
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <template>
      <v-container fluid class="pa-0 pt-2 mr-1">
        <v-sheet tile color="grey lighten-3">
          <v-row dense>
            <v-col cols="12" sm="1" md="1">
              <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <!-- dropDown menu  -->
            <v-col cols="12" sm="4" md="4">
              <center>
                <h1 class="curr-month" v-if="curr_month != null">
                  {{ curr_month }}
                </h1>
                <h1 class="curr-month" v-else>{{ title }}</h1>
              </center>
            </v-col>
            <v-col cols="12" sm="2" md="2" align="right"></v-col>

            <v-col cols="12" sm="4" md="4" align="right">
              <v-chip class="ma-2" color="brand onBrand--text" @click="setToday">Go To Today </v-chip>
            </v-col>
            <v-col cols="12" sm="1" md="1" align="right">
              <v-btn icon class="mt-2" @click="$refs.calendar.next()">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6" align="left" class="mt-2 pl-4">
              <v-menu>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined dense color="grey darken-2" v-bind="attrs" v-on="on" class="month-dropDown">
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right small>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item dense @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item dense @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item dense @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6" align="right">
              <v-select v-model="weekday" :items="weekdays" dense outlined hide-details label="weekdays"
                class="ma-2"></v-select>
            </v-col>
          </v-row>
        </v-sheet>
        <v-sheet height="410">
          <v-calendar ref="calendar" v-model="value" :weekdays="weekday" color="primary" :type="type" :events="events"
            :event-overlap-threshold="30" :event-color="getEventColor" @click:event="showEvent"
  @click:more="showMoreEvents"></v-calendar>
        </v-sheet>
        <template>
          <div class="text-center">
            <v-sheet v-if="dialog" class="custom-dialog" ref="customDialog">
              <v-card class="mx-auto">
                <v-dialog v-model="dialog" max-width="600">
  <v-card>
    <v-card-title class="headline">
      Events
    </v-card-title>

    <v-card-text>
      <v-card
        v-for="(event, index) in selectedDayEvents"
        :key="index"
        class="mb-3"
        outlined
      >
        <v-card-title class="subtitle-1">
          {{ event.name }}
        </v-card-title>

        <v-card-text>
          <div class="mb-1">
            Description: {{ event.description }}
          </div>

          <v-chip color="lightgreen" text-color="white">
            Class: {{ event.standard }}
          </v-chip>
        </v-card-text>
      </v-card>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="dialog = false">
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
                
              </v-card>
            </v-sheet>
          </div>
        </template>
      </v-container>
    </template>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {
    QuickLinkComponents: () => import("./QuickLinkComponents.vue"),
  },
  props: {
    l_id: Number,
    ay_id: Number
  },
  data: () => ({
    user: {
      name: "",
      isBirthdayToday: false
    },
    showBirthdayDialog: false,
    musicPlayer: null,
    snackbar_msg: "",
    user_type: "",
    color: "",
    snackbar: false,
    bday_list_student: [],
    isBirthdayLoaded: false,
    bday_list: [],
    quickLinks: [
      { label: 'Fee', icon: 'mdi-receipt', bg: '#e0f2fe', color: '#0284c7' },
      { label: 'Communication', icon: 'mdi-message-text', bg: '#d9f99d', color: '#15803d' },
      { label: 'Attendance', icon: 'mdi-account-check', bg: '#fee2e2', color: '#ea580c' },
      { label: 'Results', icon: 'mdi-chart-bar', bg: '#fee2e2', color: '#dc2626' },
      { label: 'Digital Learning', icon: 'mdi-laptop', bg: '#e0f2fe', color: '#0f172a' },
      { label: 'Syllabus', icon: 'mdi-file-document-outline', bg: '#ede9fe', color: '#7c3aed' }
    ],
    dialog: false,
    datetime: null,
    title: "",
    awspath: '',
    type: "month",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
    ],
    value: "",
    selectedDayEvents: [],
    events: [],
    tempevents: { name: "", description: "", std: "", grno: "" },
    selectedElement: null,
    colors: ["blue", "indigo", "deep-purple", "cyan", "green", "orange", "grey darken-1"],
    names: ["Meeting", "Holiday", "PTO", "Travel", "Event", "Birthday", "Conference", "Party"],
    months: ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    curr_month: null,
    ay: "",
    child: "",
  }),
  updated: function () {
    this.$nextTick().then(() => {
      if (this.$refs.calendar.value != "") {
        let date = this.$refs.calendar.value;
        var no = date.split("-");
        this.curr_month = this.months[parseInt(no[1])];
      }
      if (this.dialog) {
        this.adjustDialogSize();
      }
    });
  },
  watch: {
    l_id(newVal) {
      if (newVal && this.ay_id != null) {
        this.fetchChildAcademicPlans();
      }
    },
    ay_id(newVal) {
      if (newVal && this.l_id != null) {
        this.fetchChildAcademicPlans();
      }
    },
    dialog(newVal) {
      if (newVal) {
        this.adjustDialogSize();
      }
    }
  },
  mounted() {
    this.user_type = localStorage.getItem("EPS-ut");
    this.todayBirthday();
    this.fetchChildAcademicPlans();
    this.getInstructorBirthday();
    this.awspath = localStorage.getItem("awspath");
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('zoom', this.adjustDialogSize); // Listen for zoom events (browser-dependent)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('zoom', this.adjustDialogSize);
  },
  methods: {
    handleResize() {
    if (this.dialog) {
      this.$nextTick(() => {
        const dialog = document.querySelector('.custom-dialog');
        if (dialog) {
          dialog.style.top = '50%';
          dialog.style.left = '50%';
          dialog.style.transform = 'translate(-50%, -50%)';
          // Ensure the dialog width is recalculated
          dialog.style.width = window.innerWidth > 500 ? '500px' : '90vw';
          dialog.style.maxWidth = '90%';
        }
      });
    }
  },
    adjustDialogSize() {
      if (this.dialog && this.$refs.customDialog) {
        const dialog = this.$refs.customDialog;
        // Use viewport width to set a proportional size
        const baseWidth = 90; // Base width as a percentage of viewport
        const zoomLevel = window.innerWidth / document.documentElement.clientWidth; // Approximate zoom level
        const adjustedWidth = `${baseWidth / zoomLevel}vw`; // Adjust width based on zoom
        dialog.style.width = adjustedWidth;
        dialog.style.maxWidth = adjustedWidth; // Ensure max-width scales too
        // Center again after size adjustment
        dialog.style.top = '50%';
        dialog.style.left = '50%';
        dialog.style.transform = 'translate(-50%, -50%)';
      }
    },
    launchConfetti() {
      const duration = 3 * 1000;
      const animationEnd = Date.now() + duration;
      const defaults = {
        startVelocity: 45,
        spread: 360,
        ticks: 80,
        gravity: 0.9,
        scalar: 1.2,
        zIndex: 9999,
        shapes: ['circle', 'square'],
        colors: ['#bb0000', '#ffffff', '#00bb00', '#0000bb', '#ffaa00']
      };

      const interval = setInterval(() => {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          clearInterval(interval);
          return;
        }

        const particleCount = 80 * (timeLeft / duration);

        confetti(
          Object.assign({}, defaults, {
            particleCount: Math.floor(particleCount),
            origin: {
              x: Math.random(),
              y: Math.random() - 0.2
            }
          })
        );
      }, 200);
    },
    launchEmojiConfetti() {
      const emojis = ['🎉', '✨', '🎊', '🎈', '✨'];
      const duration = 3000;
      const end = Date.now() + duration;

      const interval = setInterval(() => {
        if (Date.now() > end) {
          clearInterval(interval);
          return;
        }

        const emoji = document.createElement('div');
        emoji.innerText = emojis[Math.floor(Math.random() * emojis.length)];
        emoji.style.position = 'fixed';
        emoji.style.zIndex = 9999;
        emoji.style.fontSize = `${Math.random() * 30 + 30}px`;
        emoji.style.left = `${Math.random() * 100}%`;
        emoji.style.top = `${Math.random() * 100}%`;
        emoji.style.pointerEvents = 'none';
        emoji.style.opacity = '1';
        emoji.style.transition = 'transform 3s ease-out, opacity 3s ease-out';
        emoji.style.transform = `translateY(-${Math.random() * 200 + 100}px) rotate(${Math.random() * 360}deg)`;

        document.body.appendChild(emoji);

        requestAnimationFrame(() => {
          emoji.style.transform += ' translateY(-100px)';
          emoji.style.opacity = '0';
        });

        setTimeout(() => {
          emoji.remove();
        }, 3000);
      }, 100);
    },
    closeDialog() {
      this.showBirthdayDialog = false;
      this.stopBirthdayMusic();
    },
    todayBirthday() {
      axios
        .get("/communication/todayBirthday")
        .then((res) => {
          if (res.data.flag === "YES") {
            this.user.isBirthdayToday = res.data.isBirthdayToday;
            this.user.name = res.data.birthday_name;
            if (this.user_type == "Parent" || this.user_type == "Student") {
              if (this.user.isBirthdayToday) {
                const isShown = sessionStorage.getItem("birthdayDialogShown");
                if (!isShown) {
                  this.playBirthdayMusic();
                  this.showBirthdayDialog = true;
                  this.launchConfetti();
                  this.launchEmojiConfetti();
                  sessionStorage.setItem("birthdayDialogShown", true);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    playBirthdayMusic() {
      this.stopBirthdayMusic();
      this.musicPlayer = new Audio(require('@/assets/happy-birthday-155461.mp3'));
      this.musicPlayer.loop = false;
      this.musicPlayer.play().catch(err => {
        console.warn("Music playback blocked until user interacts with the page", err);
      });
    },
    stopBirthdayMusic() {
      if (this.musicPlayer) {
        this.musicPlayer.pause();
        this.musicPlayer.currentTime = 0;
        this.musicPlayer.src = "";
        this.musicPlayer = null;
      }
    },
    async getInstructorBirthday() {
      try {
        const res = await axios.post("/communication/getInstructorBirthday");
        if (res.data.flag == "YES") {
          this.bday_list = res.data.bday_list;
          this.bday_list_student = res.data.bday_list_student;
          this.isBirthdayLoaded = true;
        } else {
          this.showSnackbar("red", res.data.snackbar);
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
      } catch (err) {
        console.log("err", err);
        this.onerror(err);
      } finally {
        console.log("bye...");
      }
    },
    fetchChildAcademicPlans() {
      const hasProps = this.l_id != null && this.ay_id != null;
      const data = hasProps ? { ay_name: this.ay_id, lid: this.l_id } : null;
      axios
        .post("/AcademicPlanner/getChildAcademicPlans", data)
        .then((res) => {
          if (
            res.data.flag === "YES" &&
            res.data.planning_list &&
            res.data.planning_list.length
          ) {
            this.events = res.data.planning_list;
            console.log("in API", this.events);
          }
          this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    },
    viewDay({ date }) {
      this.value = date;
      this.type = "day";
    },
    setToday() {
      this.value = "";
      this.curr_month = null;
    },
    dateTime() {
      let dt = this.formatDate(this.datetime, true);
      const formData = {
        datetime: dt,
      };
      axios
        .post("tryNError/dateTime", formData)
        .then((res) => {
          if (res.data.msg == "200") {
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showEvent({ nativeEvent, event }) {
      this.tempevents.name = event.name;
      this.tempevents.description = event.description;
      this.tempevents.std = event.standard;
      this.tempevents.grno = event.divissionoffering;
      this.selectedElement = nativeEvent.target;
       this.selectedDayEvents = [event];
      this.dialog = true;
      console.log(this.selectedElement);
    },
    showMoreEvents({ date }) {
  const eventsOfDay = this.events.filter(e => e.start === date);

  if (!eventsOfDay || eventsOfDay.length <= 1) return;

  // this.selectedDayEvents = eventsOfDay;
this.selectedDayEvents = [
  ...new Map(eventsOfDay.map(e => [e.id, e])).values()
];
  this.dialog = true;
},

    getdata({ day }) {
    },
    getEvents() {
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime ? `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}` : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    getMonthYYYYMMDD(date) {
      var num_month = date.split("-");
      var months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      return months[parseInt(num_month[1])];
    },
    handleClick(link) {
      console.log('Clicked:', link.label);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = "Cant load profile data";
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    }
  }
};
</script>

<style scoped>
.v-icon {
  transition: transform 0.2s ease;
}

.v-card:hover .v-icon {
  transform: scale(1.2);
}

border-bottom {
  border-bottom: 1px solid #e5e7eb;
}

.animated-dialog {
  background: linear-gradient(135deg, #ffe0ec, #ffffff);
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(255, 105, 180, 0.3);
  overflow: hidden;
}

.dialog-text-animate {
  animation: fade-slide-in 1s ease forwards;
}

@keyframes fade-slide-in {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.custom-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  max-width: 90%; /* Limit max width to 90% of viewport */
  width: 500px; /* Fixed width, adjust as needed */
  min-width: 300px; /* Minimum width to prevent it from getting too small */
  background: transparent;
}

.custom-dialog .v-card {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  width: 100%; /* Ensure the card fills the dialog */
  height: auto; /* Allow height to adjust based on content */
}

.responsive-text {
  font-size: 1rem; /* Use rem for consistent scaling */
  line-height: 1.5;
  max-width: 100%; /* Prevent text overflow */
}

.custom-dialog .v-card-title {
  font-size: 1.5rem; /* Use rem for consistent scaling */
}

.custom-dialog .v-btn {
  font-size: 0.9rem; /* Use rem for consistent scaling */
}

@media (max-width: 600px) {
  .custom-dialog {
    width: 90vw; /* Use vw for smaller screens but limit max-width */
    max-width: 500px;
  }
  .custom-dialog .v-card-title {
    font-size: 1.2rem; /* Adjust for smaller screens */
  }
  .custom-dialog .v-btn {
    font-size: 0.8rem; /* Adjust for smaller screens */
  }
}
</style>